import each from './each';
export default each;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/for-in.js
// module id = 77
// module chunks = 0